module.exports = __webpack_public_path__ + "img/mobile/PromoBetBar/panel_background@3x.png?1.0.24";


//////////////////
// WEBPACK FOOTER
// ./out/img/mobile/PromoBetBar/panel_background@3x.png
// module id = 204
// module chunks = 0